var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLookup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 0C3.63401 0 0.5 3.13401 0.5 7C0.5 10.866 3.63401 14 7.5 14C9.07234 14 10.5236 13.4816 11.6922 12.6064L15.2071 16.1213L16.6213 14.7071L13.1064 11.1922C13.9816 10.0236 14.5 8.57233 14.5 7C14.5 3.13401 11.366 0 7.5 0ZM2.5 7C2.5 4.23858 4.73858 2 7.5 2C10.2614 2 12.5 4.23858 12.5 7C12.5 9.76142 10.2614 12 7.5 12C4.73858 12 2.5 9.76142 2.5 7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLookup);
export default __webpack_public_path__ + "static/media/lookup.bc8c3cc3c1db83438b001322d9261eea.svg";
export { ForwardRef as ReactComponent };